import { userConstants } from "../../constants/ActionTypes";

const initialState = {
    createPayoutModal:false,
    contactList:[],
    linkList:[],
    linkListDetail:{},
    name:"",
    mobile:"",
    email:"",
    list_contact_type:"",
    contact_email:"",
    contact_phone:"",
    contact_type:"",
    contact_name:"",
    add_new_contact:false,
    payoutDetailSection:false,
    createdContact:false,
    createdPostContact:false,
    securityCheck:false,
    post_name:"",
    post_mobile:"",
    post_email:"",
    post_list_contact_type:"",
    payment_type:"",
    payout_amount:"",
    payout_purpose:"",
    selectedContactNextStep:false,
    payoutlink_verify_otp:"",
    complete_addcontact:false,
    showContactList:false,
    complete_addPayoutdetails:false,
    viewPaylinkDetail:false,
    sharePayoutLinkModal:false,
    available_balance:"",
    account_type:"",
    contact_id:"",
    expiry_date:"",
    paylinkId:"",
    paylinkUrl:"",
    contact_type_list_items : [
        { value: 'Customer', label: 'Customer' },
        { value: 'Merchant', label: 'Merchant' },
        // {value:'Employee',label:'Employee'},
        { value: 'Vendor', label: 'Vendor' },
        { value: 'Supplier', label: 'Supplier' }
    ],

};

export function payoutLinks(state = initialState, action) {
    switch (action.type) {  
        case userConstants.PAYOUTLINK:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}